import { StyleSheet } from 'react-native';

import { PALETTE } from '../../constants';

export default StyleSheet.create({
  root: {
  },
  infoContainer: {
    marginTop: 5,
    marginBottom: 5,
    minHeight: 32,
  },
  infoContainerText: {
    textAlign: 'center',
  },
  errorContainer: {
    backgroundColor: PALETTE.errorColor,
    marginTop: 66,
    marginBottom: 26,
    paddingVertical: 5,
    paddingHorizontal: 10,
    minHeight: 32,
  },
});
